import {
  ACCOUNT_SETTINGS_PATHS,
  ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
} from '../routes/account/accountSettingPaths';
import {AUTOMATIONS_PATH} from '../routes/automations/automationsPaths';
import {
  TEAM_MEMBERS_PATH,
  TEAM_SERVICE_ACCOUNTS_PATH,
  TEAM_SETTINGS_PATH,
} from '../routes/team/teamPaths';
import {
  getRouteMatch,
  isProfilePath,
  isSpecificPath,
  isUserSettingsPath,
} from '../routes/utils';
import {decodeURIComponentSafe} from '../util/urls';

const ORG_SETTINGS_PATHS = [
  ...ACCOUNT_SETTINGS_PATHS,
  ...ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
];

const TEAM_PATHS = [
  TEAM_MEMBERS_PATH,
  TEAM_SERVICE_ACCOUNTS_PATH,
  TEAM_SETTINGS_PATH,
];

/** Header title for account-level pages; undefined for product pages. */
export function accountLevelHeaderTitle(pathname: string): string | undefined {
  if (isUserSettingsPath(pathname)) {
    return 'User settings';
  }
  if (isSpecificPath(pathname, [AUTOMATIONS_PATH])) {
    return 'Automations';
  }
  const params: {orgName?: string; entityName?: string} =
    getRouteMatch(pathname)?.params ?? {};
  if (isSpecificPath(pathname, ORG_SETTINGS_PATHS) && params.orgName != null) {
    return decodeURIComponentSafe(params.orgName);
  }
  if (
    (isProfilePath(pathname) || isSpecificPath(pathname, TEAM_PATHS)) &&
    params.entityName != null
  ) {
    return decodeURIComponentSafe(params.entityName);
  }
  return undefined;
}
